import { toError } from 'api/parsers/transport-error';
import {
  keysToSnakeCase,
  keysToCamelCase,
} from '@wix/wix-vod-shared/dist/src/common/utils/object';
import { PrivateWidgets } from '@wix/wix-vod-api-site-based/dist/src/private/services/widgets/widgets';
import { catalogServiceConfig } from 'api/config/catalog-service';
import { hosts } from '@wix/wix-vod-shared/dist/src/common/settings/settings';

export const service = new PrivateWidgets(catalogServiceConfig);

export const updateWidgetSettings = (widgetId, settings) =>
  service
    .updateSettings(widgetId, keysToSnakeCase(settings))
    .then(keysToCamelCase)
    .catch(({ response }) => toError(response));

export const updateWidget = (widgetId, widgetMetadata) =>
  service
    .create(widgetId, keysToSnakeCase(widgetMetadata))
    .then(keysToCamelCase)
    .catch(({ response }) => toError(response));

export const getWidgetSettings = widgetId =>
  service
    .getSettings(widgetId)
    .then(keysToCamelCase)
    .catch(({ response }) => toError(response));

export const getWidgetSettingsByInstanceId = instanceId =>
  service
    .getSettingsByInstanceId(instanceId)
    .then(response => keysToCamelCase(response.data));

export const buildVideoCardsDeeplinkUrl = ({
  channelId,
  videoId,
  fallbackUrl,
  instance,
}) =>
  service.buildVideoCardsDeeplinkUrl({
    host: hosts.publicCatalog,
    channelId,
    videoId,
    fallbackUrl,
    instance,
  });

export const buildChannelCardsDeeplinkUrl = ({
  channelId,
  fallbackUrl,
  instance,
}) =>
  service.buildChannelCardsDeeplinkUrl({
    host: hosts.publicCatalog,
    channelId,
    fallbackUrl,
    instance,
  });
